<template>
  <div class="contentBox">
    <div class="bg">
      <div class="cont">
        <button class="btn btn-draw" @click="drawShow"></button>
        <p>购买前请验证头马会员身份·优惠仅限活动期有效</p>
      </div>
    </div>
    <div class="codeBox" v-if="codeType">
      <div class="bg">
        <button class="btn btn-close" @click="loginHide('code')">+</button>
        <div class="txt mobile">
          <p class="">手机号</p>
          <input type="number" placeholder="请输入手机号" v-model="mobile" @input="numCheck(mobile,11,'mobile')">
        </div>
        <div class="txt code">
          <p class="">验证码</p>
          <div class="code-bg">
            <input type="number" placeholder="请输入验证码" v-model="code"/>
            <button class="btn btn-code" @click="getCode">{{codeTxt}}</button>
          </div>
        </div>
        <button class="btn btn-sub" @click="loginSub"></button>
      </div>
    </div>

    <div class="imgBox" v-if="imgType" >
      <div class="bg">
        <button class="btn btn-close" @click="loginHide('img')">+</button>
        <p class="img-title">请根据例图上传凭证截图</p>
        <div class="img-item img-item1">
          <p>例图</p>
          <img src="~@/assets/images/vip-icon1.png" alt="">
        </div>

        <div class="img-item img-item2" v-loading="loadingImg" :element-loading-text="loadTxt">
          <p>上传凭证</p>
          <div class="write-text">
              <div style="display:inline-block;">
                <div class="img"  v-show="addObj.image" >
                  <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
                </div>
              </div>
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj"
                list-type="picture-card"
                :before-upload="beforeUploadImg"
                :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList)}"
                :on-progress="handleProgressImg"
                :on-remove="handleRemoveVideo"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img
                  width="100%"
                  :src="'https://pic.bi-rong.com/' + addObj.image"
                  alt=""
                />
              </el-dialog>
            </div>
        </div>

        <button class="btn btn-img" @click="imgSub"></button>
      </div>
    </div>

    <div class="payBox" v-if="payType">
      <div class="contv">
        <button class="btn btn-close" @click="loginHide('pay')">+</button>
        <p class="txt txt1">验证成功</p>
        <p class="txt txt2">您的专属身份：{{payData.vip==1?'头马会员':payData.vip==2?'非会员':'特点俱乐部会员'}}</p>
        <p class="txt txt3">限时专享价 <span>{{payData.money}}元</span></p>
        <div class="payList">
          <div class="pay-item pay-wx" :class="payID==1?'select':''" v-if="isWx" @click="payChoose(1)">
            <i class="icon"></i>
            <span class="icon-wx"></span>
            <p>微信支付</p>
          </div>
          <div class="pay-item pay-zfb" :class="payID==2?'select':''" @click="payChoose(2)" v-if="!isWx">
            <i class="icon"></i>
            <span class="icon-zfb"></span>
            <p>支付宝支付</p>
          </div>
          <button class="btn btn-pay" @click="orderSub">立即支付，享受权益</button>
        </div>
      </div>
    </div>

    <div class="loadBox" v-if="loadType">
      <div class="contv">
        <div class="progress">
          <div class="progress-bg">
            <!-- <i class="progress-line" :style="width:{{loadNum}}%"></i> -->
            <i class="progress-line" :style="{ width: loadNum + '%' }"></i>
          </div>
          <p>{{loadNum}}%</p>
        </div>
        <p class="load-txt">AI验证中...</p>
      </div>
    </div>

    
    <div class="orderBox" v-if="orderType">
      <div class="contv">
        <button class="btn btn-hide" @click="updownSub">下载智能演讲教练app</button>
      </div>
    </div>
  </div>

</template>
<script>
import { sendVerificationCode ,NewcaptchaLogin,giveVip,getUploadToken ,getToastmastersVip,addOrder,getOrderStatus} from "@/assets/js/api";
export default {
  name: "login",
  data() {
    return {
      codeType:false,
      subType:false,
      mobile:'',
      code:'',
      isSendCode:false,
      countDownNum:60,
      codeTxt:'获取验证码',
      token:'',
      codeNum:'',
      clickType:false,
      clickTxt:'',
      imgType:false,
      addObj:{
        image:'',
      },
      uploadObj: {
        token: "",
        key: "",
      },
      uploadUrl: "",
      loading:false,
      loadTxt:'',
      payType:false,
      payData:'',
      loadType:false,
      loadNum:0,
      dialogVisible:false,
      loadingImg:false,
      payID:1,
      orderTime:'',
      orderType:false,
      isWx:false
    };
  },
  components: {
    
  },
  watch: {
    $route() {
      window.location.reload();
    }
  },
  mounted(){
    var that = this;
    this.font_resize();
    document.title='头马会员'
    this.getToken();
    var userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('micromessenger') !== -1) {
        // 确认是微信浏览器
        console.log('用户使用的是微信浏览器');
        that.isWx = true;
    } else {
        // 不是微信浏览器
        console.log('用户使用的不是微信浏览器');
        that.isWx = false;
    }
  },
  methods: {
    font_resize(){
      var size=document.documentElement.clientWidth / 750 * 100;
      document.querySelector('html').style.fontSize=size + 'px';
    },

    drawShow(){
      this.codeType = true;
    },

    async getOrder(){
      var that = this;
      try {
        const response = await getOrderStatus({order_id:that.order_id},this.token);
        if(response.code == 200){
          clearInterval(that.orderTime)
          if(response.data.order_status == 0){
            that.$message('订单未支付');
            return false;
          } else if(response.data.order_status == 1){
            that.payType = false;
            that.orderType = true;
            return false
          } else {
            that.$message('订单已退款');
            return false;
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
      
    },

    //获取验证码
    async getCode(){
      var that = this;
      var mobile = this.mobile;
      var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      if(mobile === '' || !regex.test(mobile)){
          that.$message('请输入正确的手机号码！');
          return false;
      };
      if(this.isSendCode){
          that.$message('请勿重复点击！');
          return false;
      };
      var data = {
        mobile:mobile
      };
      try {
        const response = await sendVerificationCode(data);
        if(response.code == 200){
          that.isSendCode = true;
          var setCountDown = setInterval(function() {
              that.countDownNum--;
              that.codeTxt = that.countDownNum+'s';
              if (that.countDownNum == 0) {
                  clearInterval(setCountDown);
                  that.countDownNum = 60;
                  that.isSendCode = false;
                  that.codeTxt = '重新发送';
              };
          }, 1000);
        } else {
          that.countDownNum = 60;
          that.isSendCode = false;
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
        that.countDownNum = 60;
        that.isSendCode = false;
        that.$message(data.msg);
      }
    },

    async loginSub(){
      var that = this;
      if(this.mobile == ''){
        this.$message('请输入正确的账号！');
        return false;
      }
      if(this.code == ''){
        this.$message('请输入正确的验证码！');
        return false;
      }
      try {
        const response = await NewcaptchaLogin({mobile:this.mobile,code:this.code});
        if(response.code == 200){
          that.token = response.data.token;
          that.codeType = false;
          that.mobile = '';
          that.code = '';
          that.isSendCode = false;
          that.countDownNum = 60;
          that.codeTxt = '获取验证码';
          that.imgType = true;
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    loginHide(type){
      var that = this;
      if(type == 'code'){
        that.codeType = false;
        that.mobile = '';
        that.code = '';
        that.isSendCode = false;
        that.countDownNum = 60;
        that.codeTxt = '获取验证码';
      } else if(type == 'img'){
        that.imgType = false;
        that.addObj.image = '';
      } else if(type == 'pay'){
        that.payType = false;
        that.payData = '';
      }
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },

    async clickSub(){
      var that = this;
      if(this.codeNum == ''){
        this.$message('请输入正确的兑换码！');
        return false;
      }
      try {
        const response = await giveVip({code:this.codeNum},this.token);
        if(response.code == 200){
          that.clickType = true;
          that.clickTxt = '兑换成功';
          that.codeNum = '';
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    updownSub(){
      var client = '';
      var u = navigator.userAgent,app = navigator.appVersion;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      var isIOS = !u.match(/\(i[^;]+;( U;)? CPU,+Mac OS X/);
      if(isAndroid){
          client = 'android'
      }else {
          client = 'ios'
      };
      if (client == 'ios') {
        window.location.href = 'https://apps.apple.com/cn/app/智能演讲教练/id6744727526';
      } else {
        window.location.href = 'https://m.malink.cn/s/UzyUva';
      };
    },

    beforeUploadImg(file) {
      this.loadingImg = true;
      this.loadTxt = '上传中...';
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessImg(response, file, fileList) {
      this.addObj.image = response.key;
      this.loadingImg = false;
      this.uploadObj.key = "";
      this.loadTxt = '上传中...';
      this.$forceUpdate();
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveVideo(response, file, fileList,index) {
      this.addObj.image = "";
    },

    async imgSub(){
      var that = this;
      if(this.addObj.image == ''){
          that.$message('请先上传图片');
          return false;
      }
      this.imgType = false;
      this.loadType = true;
      var time = setInterval(function(){
        if(that.loadNum == 90){
          clearInterval(time);
          return false;
        }
        that.loadNum++;
      },500)
      try {
        const response = await getToastmastersVip(that.addObj,this.token);
        if(response.code == 200){
          that.loadNum = 100;
          clearInterval(time);
          setTimeout(function(){
            that.loadType = false;
            that.payType = true;
            that.payData = response.data;
          },1000)
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    payChoose(type){
      this.payID = type;
    },

    async orderSub(){
      var that = this;
      if(that.payID == 1){
        that.$message('暂无微信支付，请使用支付宝');
        return false;
      }
      if(that.isWx){
          that.$message('请复制链接，在浏览器中支付');
          return false;
      }
      var obj = {
        from_type:'toastmasters',
        desc:'演讲教练-头马会员',
        type:that.payID==1?'102':'201',
        money:that.payData.money
      }
      try {
        const response = await addOrder(obj,this.token);
        if(response.code == 200){
          that.order_id = response.data.order_id;
          that.orderTime = setInterval(function(){
            that.getOrder();
          },1000)
          if(that.payID==1){
            window.location.href = response.data.url
          } else {
            window.location.href = response.data.orderInfo
          }
        } else {
          that.$message(data.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    }
  }  
};
</script>
<style scoped>
  button{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    background-color: transparent;
  }
  .contentBox{
    overflow-y: auto;
    overflow-x: hidden;
  }

  .contentBox .bg{
    background-image: url(~@/assets/images/vip-bg.png);
    width: 100%;
    height: 16.24rem;
    background-size: 100% 16.24rem;
    position: relative;
  }

  .cont{
    position: absolute;
    bottom: .3rem;
    left: 50%;
    transform: translate(-50%,0);
    width: 100%;
    text-align:  center;
  }

  .cont p{
    font-size: .24rem;
    color: #777777;
    display: block;
    text-align: center;
    margin-top: .1rem;
  }

  .btn-draw{
    background-image: url(~@/assets/images/code-btn1.png);
    width: 5rem;
    height: 1.09rem;
    background-size: 5rem 1.09rem;
  }

  .orderBox,
  .loadBox,
  .imgBox,
  .codeBox{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .6);
  }

  .codeBox .bg{
    background-image: url(~@/assets/images/code-bg1.png);
    width: 100%;
    height: 6.79rem;
    background-size: 100% 6.79rem;
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    padding: 1rem .3rem;
    box-sizing: border-box;
  }

  .imgBox .bg{
    background-image: url(~@/assets/images/vip-bg1.png);
    width: 100%;
    height: 9rem;
    background-size: 100% 9rem;
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    padding: 1rem .3rem;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .imgBox .img-title{
    font-size: .4rem;
    color: #333333;
    display: block;
    text-align: center;
  }
  
  .imgBox .img-item{
    display: block;
    margin-bottom: .3rem;
  }

  .imgBox .img-item p{
    display: block;
    font-size: .3rem;
    color: #333333;
    margin-bottom: .2rem;
  }

  .imgBox .img-item img{
    width: 6.9rem;
    height: 3.88rem;
    display: block;
    margin: 0 auto;
  }

  .imgBox>>> .el-upload--picture-card{
    width: 100%;
  }

  .imgBox .btn-img{
    background-image: url(~@/assets/images/vip-btn1.png);
    width: 5rem;
    height: 1.09rem;
    background-size: 5rem 1.09rem;
    display: block;
    margin: 0.6rem auto 0;
  }

  .codeBox .bg .txt{
    margin-bottom: .3rem;
  }

  .codeBox .bg .txt p{
    color: #333333;
    font-size: .3rem;
    margin-bottom: .2rem;
  }

  .codeBox .bg .mobile input{
    width: 100%;
    height: .96rem;
    line-height: .96rem;
    color: #AAAAAA;
    font-size: .28rem;
    border-radius: .2rem;
    box-sizing: border-box;
    padding: 0 .3rem;
  }

  .codeBox .bg .code .code-bg{
    background-color: #fff;
    border-radius: .2rem;
  }

  .codeBox .bg .code input{
    width: 50%;
    height: .96rem;
    line-height: .96rem;
    display: inline-block;
    vertical-align: top;
    color: #AAAAAA;
    font-size: .28rem;
    box-sizing: border-box;
    padding: 0 .3rem;
    background-color: transparent;
  }

  .codeBox .bg .code .btn-code{
    font-size: .24rme;
    line-height: .96rem;
    height: .96rem;
    color: #6E2FFF;
    display: inline-block;
    vertical-align: top;
    width: 50%;
    text-align: right;
    padding-right: .2rem;
    box-sizing: border-box;
  }

  .btn-close{
    font-size: 1rem;
    color: #666666;
    position: absolute;
    top: 0rem;
    right: .3rem;
    transform: rotate(45deg);
  }

  .btn-sub{
    background-image: url(~@/assets/images/code-btn2.png);
    width: 5.7rem;
    height: 1.09rem;
    background-size: 5.7rem 1.09rem;
    display: block;
    margin: 0.6rem auto 0;
  }

  ::-webkit-scrollbar{
    width: 1px;
  }

  .payBox{
    width: 100%;
    height: 100%;
    background-color: rgba(51, 51, 51, .6);
    position: fixed;
    top: 0;
    left: 0;
  }

  .payBox .contv{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-image: url(~@/assets/images/vip-bg2.png);
    width: 6.1rem;
    height: 7.2rem;
    background-size: 6.1rem 7.2rem;
    background-color: transparent;
    box-sizing: border-box;
    padding: .6rem .3rem;
    text-align: center;
  }

  .payBox .contv .txt{
    color: #333333;
  }

  .payBox .contv .txt1{
    font-size: .36rem;
    margin-bottom: .5rem;
  }

  .payBox .contv .txt2{
    font-size: .32rem;
    margin-bottom: .75rem;
  }

  .payBox .contv .txt3{
    font-size: .3rem;
  }

  .payBox .contv .txt3 span{
    color: #FD5644;
    font-size: .46rem;
    display: block;
  }

  .payBox .contv .payList{
    font-size: 0;
    display: block;
    margin-top: .47rem;
  }

  .payBox .contv .payList .pay-item{
    display: inline-block;
    vertical-align: top;
    margin-right: .4rem;
  }

  .payBox .contv .payList .pay-item:last-child{
    margin-right: 0;
  }

  .payBox .contv .payList .pay-item .icon{
    width: .4rem;
    height: .4rem;
    border-radius: 100%;
    border: solid .02rem #ccc;
    display: inline-block;
    vertical-align: middle;
    margin-right: .24rem;
  }

  .payBox .contv .payList .pay-item.select .icon{
    background-image: url(~@/assets/images/vip-pay1.png);
    background-size: .4rem .4rem;
    border: none;
  }

  .payBox .contv .payList .pay-item .icon-zfb,
  .payBox .contv .payList .pay-item .icon-wx{
    width: .5rem;
    height: .5rem;
    background-image: url(~@/assets/images/vip-wx.png);
    background-size: .5rem .5rem;
    display: inline-block;
    vertical-align: middle;
    margin-right: .14rem;
  }

  .payBox .contv .payList .pay-item .icon-zfb{
    background-image: url(~@/assets/images/vip-zfb.png);
  }

  .payBox .contv .payList .pay-item p{
    font-size: .26rem;
    color: #333333;
    display: inline-block;
    vertical-align: middle;
  }

  .payBox .contv .btn-pay{
    background-color: #6E2FFF;
    font-size: .3rem;
    color: #fff;
    width: 3.92rem;
    height: .82rem;
    display: block;
    margin: 0.7rem auto 0;
    border-radius: .45rem;
  }

  .loadBox .contv{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    border-radius: .2rem;
    box-sizing: border-box;
    padding: .6rem .45rem;
    width: 70%;
  }

  .loadBox .contv .progress{
    display: block;
    margin-bottom: .2rem;

  }

  .loadBox .contv .progress .progress-bg{
    width: 3.4rem;
    height: .38rem;
    border-radius: 1.02rem;
    border: solid .04rem #6E2FFF;
    box-sizing: border-box;
    padding: .04rem;
    display: inline-block;
    vertical-align: top;
  }

  .loadBox .contv .progress .progress-bg .progress-line{
    width: 0%;
    height: 100%;
    display: block;
    background-color: #6E2FFF;
    border-radius: 1.02rem;
    transition: all 1s;
  }

  .loadBox .contv .progress p{
    font-size: .28rem;
    color: #6E2FFF;
    display: inline-block;
    vertical-align: top;
    margin-left: .2rem;
  }

  .loadBox .contv .load-txt {
    margin-top: .2rem;
    font-size: .28rem;
    color: #6E2FFF;
    display: block;
    text-align: center;
  }

  .orderBox .contv{
    width: 5.2rem;
    height: 5.07rem;
    background-image: url(~@/assets/images/vip-icon2.png);
    background-size: 5.2rem 5.07rem;
    background-color: transparent;
  }

  .orderBox .contv .btn{
    width: 3.92rem;
    height: .82rem;
    background-color: #6E2FFF;
    color: #fff;
    border-radius: .45rem;
    position: absolute;
    bottom: .6rem;
    left: 50%;
    transform: translate(-50%,0);
    font-size: .3rem;
  }
</style>



// WEBPACK FOOTER //
// src/mobile/vipBuy.vue